export default "__VITE_ASSET__BTsfLT$b__"